import ComponentBase from 'components/_base/ComponentBase';
import {
	HOTEL_DETAILS,
	RESULTS_DESTINATION,
	DESTINATIONS_TREE
} from '../../globals/widgetTypes';

export default ComponentBase.extend({
	template: require('./hotelLocation.hbs'),
	componentClass: 'hotel-location',
	events: {
		click: 'showLocation'
	},

	initialize(config) {
		if (!this.templateConfig.iconClassName) {
			this.templateConfig.iconClassName = 'lmm-icon-my-location';
		}
		if (this.widget.isMobileVersion) {
			this.componentClass += '-mobile-version';
		}
		ComponentBase.prototype.initialize.call(this, config);
	},

	showLocation() {
		switch (this.widget.typeWidget) {
			case DESTINATIONS_TREE:
				this._moveToDestinationsRegion();
				break;
			case HOTEL_DETAILS:
				this._moveToMainHotel();
				break;
			case RESULTS_DESTINATION:
                this.widget.map.fitBounds(this.widget.initialBounds);
				break;
			default:
				break;
		}
	},

	_moveToMainHotel() {
		const coords = new google.maps.LatLng({
			lat: this.widget.hotelsJson.mainHotel.position.lat,
			lng: this.widget.hotelsJson.mainHotel.position.lng
		});
		this.map.panTo(coords);
		if (this.map.getZoom() !== this.widget.config.defaultView.zoom) {
			this.map.setZoom(this.widget.config.defaultView.zoom);
		}
	},

	_moveToDestinationsRegion() {
		let destination = {
			regionId: this.widget.config.initialDestinationId
		};
		this.widget.bus.trigger('LOCATION_TREE', destination);
	}
});



// WEBPACK FOOTER //
// ./src/components/hotelLocation/HotelLocation.js